<div class="paginator-wrapper">
  <p-paginator
    [first]="firstIndex"
    [rows]="pageSize"
    [totalRecords]="totalRecords"
    [rowsPerPageOptions]="pageSizeOptions"
    [dropdownAppendTo]="'body'"
    (onPageChange)="onPageChange($event)"
    >
  </p-paginator>

  <div class="paginator-summary" *ngIf="totalPages > 0">
    <small>Page {{ currentPageNumber }} of {{ totalPages }}</small>
  </div>
</div>
